export function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) { return pair[1]; }
    }
    return (false);
}
/**
 * 
 * @returns 

 */
//支付成功时获取本地存储的query参数
function getQueryStrForLocal() {
    let queryStr = localStorage.getItem("pay_query_str") || "";
    return queryStr
}


//支付成功时获取本地存储的token
function getTokenForLocal(variable) {
    let query = getQueryStrForLocal().substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) { return pair[1]; }
    }
    return '';
}
//console.log(getTokenForLocal('token'))

export function compareVersion(v1, v2) {
    if (v1 == v2) {
        return 0;
    }
    var vs1 = v1.split(".").map(a => parseInt(a));
    var vs2 = v2.split(".").map(a => parseInt(a));

    var length = Math.min(vs1.length, vs2.length);
    for (var i = 0; i < length; i++) {
        if (vs1[i] > vs2[i]) {
            return 1;
        } else if (vs1[i] < vs2[i]) {
            return -1;
        }
    }
    if (length == vs1.length) {
        return -1;
    } else {
        return 1;
    }
}

function CURRENT_ENV_PRE_FN(){
    let host0 = window.location.hostname;
    if(host0.indexOf("192.") > 0 || host0.indexOf("80") > 0) return "dev";//vue项目 本地调试设置变量
    if (host0.indexOf("dev") > 0) return "dev";
    if (host0.indexOf("beta") > 0) return "beta";
    return '';
}

// appversion=11.5.0 版本号
// love_stock_pro_is_show_all=1 // 不知道是啥，但是得穿
// source=ios 来源
// u_id=44324 用户id
// user_id=44324 用户id（和上面一样，都得穿不知道为啥

// origin_user_id=0 // 审核用的
// bundle_name=love_stock_pro 不知道是啥，但是得穿

// 这几个是是接口会用到的
export const queryStr = location.search || getQueryStrForLocal();
export const appversion = getQueryVariable('appversion') || '';
export const love_stock_pro_is_show_all = getQueryVariable('love_stock_pro_is_show_all') || 1;
export const source = getQueryVariable('source') || '';
export const user_id = getQueryVariable('user_id') || '';
export const u_id = getQueryVariable('u_id') || '';
export const origin_user_id = getQueryVariable('origin_user_id') || 0;
export const bundle_name = getQueryVariable('bundle_name') || 'love_stock_pro';
export const change_bgImg = getQueryVariable('change_bgImg') || 'no'; 

export const CURRENT_ENV_PRE = CURRENT_ENV_PRE_FN() || '';
// 
// 调试阶段写死 - 46 老师的
// export const token =  getQueryVariable('token') || getTokenForLocal('token') || "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC9hcGkuYWlndXBpYW8uY29tXC92MVwvYXVkaW9fbGl2ZSIsImlhdCI6MTcxNjI4MDkzNSwiZXhwIjoxODcxODAwOTM1LCJuYmYiOjE3MTYyODA5MzUsImp0aSI6Ik9OWkNnTFQ2a3pENkthS0giLCJzdWIiOjQ0MzI0LCJwcnYiOiI1Nzk2ZDgwNmI0ZWIwY2Y0OTk3OTEzMWMyYjllOWI2YzAyMjBhNTk5In0.alyqIU33WeYup-_E-WVqYWdc_kGzQuLzOI4CK5b62Wg";
// 调试阶段写死 - 用户的
// export const token =  getQueryVariable('token') || getTokenForLocal('token') || "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC9hcGlkZXYuYWlndXBpYW8uY29tXC92MVwvYWNjZXNzXC90b2tlbiIsImlhdCI6MTcxODI1ODI3NiwiZXhwIjoxNzMzODEwMjc2LCJuYmYiOjE3MTgyNTgyNzYsImp0aSI6Im1Kanp5ZjJUNUdTMnlTYWciLCJzdWIiOjc1OTAxMywicHJ2IjoiNTc5NmQ4MDZiNGViMGNmNDk5NzkxMzFjMmI5ZTliNmMwMjIwYTU5OSJ9.frEmo8LcKSAEcqlCG7aFkWIDrLRjlNTQ2EB_APrcO9w";
let get_token = getQueryVariable('Authorization') || getTokenForLocal('Authorization');
export const token = decodeURIComponent(get_token);

// 下面的目前还没用到，直接copy爱股圈的代码

export const textSize = getQueryVariable('textSize') || 'normal';
export const detailTextSize = getQueryVariable('detailTextSize') || 'normal';

// 是否从 user_home（H5 投顾主页）跳进来的：主页里的卡片会带 fromHome=yes，APP 其他列表入口都不传
// 这里用函数而不是常量：SPA 内部路由跳转时 location.search 会变化，需要实时读取
export function isFromHome() {
    return getQueryVariable('fromHome') == 'yes';
}

export const channel_code = getQueryVariable('channel_code') || '';
export const device_id = getQueryVariable('device_id') || '';
export const is_large_pay = getQueryVariable('is_large_pay') || 0;
export const ext_prd_id = getQueryVariable('ext_prd_id') || '';
export const ext_id = getQueryVariable('ext_id') || '';
export const is_admins = getQueryVariable('isAdmins') || 'no';
export const scroll_page = getQueryVariable('scrollPage') || 'no';
export const close_pay = getQueryVariable('close_pay') || 'no';
export const coupon_id = getQueryVariable('coupon_id') || '';

//跳转携带参数
export const queryStrPageTo = `appversion=${appversion}&love_stock_pro_is_show_all=${love_stock_pro_is_show_all}&source=${source}&user_id=${user_id}&u_id=${u_id}&origin_user_id=${origin_user_id}&bundle_name=${bundle_name}&detailTextSize=${detailTextSize}&Authorization=${token}&textSize=${textSize}`;
// device_model=V2002A
// sign=9a093c84d255c2aef78341914fda1baf
// vtoken=6b3880be4dd0add32b95d750eb37091e
// device_brand=vivo
// igptoken=MTI3LjAuMC4xXzE3MTcwNTY2MzRfMTcxNzA1NjAzNF9kZGNlZTk5NDUxNzAwNmZmMzZmYmNlNjUxMWU0YzdhNw%3D%3D
// mds=8270551c8f6db31d0a0e5ebdebd53573

// close_pay=no
// origin_user_id=0
// device_id=3519f1e15df92a4d142bcab0569cc668b4f5506853e3fcec80e5c18e07e76e6d
// appversion=11.5.2
// channel_code=Channel_dev
// source=android
// u_id=24
// user_id=24
// time=1717056034